import React from "react";
import { SelectInput } from "react-admin";
import dataProviderFactory from "../../dataProvider";
import { GET_LIST } from "react-admin";
import { isNil, filter } from "ramda";

export class CustomBaseFilter extends React.Component {
  constructor(props) {
    super(props);
    this.offset = 0;
    this.state = { data: [] };
  }

  async fetchLocations() {
    const dataProvider = await dataProviderFactory("rest");
    const locations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const baseLocations = filter(location => {
      return isNil(location.base_location_id);
    }, locations.data);

    return baseLocations;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.props.input.value) {
      this.setState({ value: nextProps.input.value });
    }
  }

  async componentDidMount() {
    const dataItems = await this.fetchLocations();
    const data = { data: dataItems };
    this.setState(data);
  }
  render() {
    return (
      <div>
        <span>
          <SelectInput
            source={this.props.source}
            choices={this.state.data}
            {...this.rest}
            optionText="location_short_name"
            optionValue="id"
            label={this.props.label}
            allowEmpty={true}
            defaultValue={null}
          />
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/selectboxfilter/customBaseFilter.js